export default "/img/GT.ec4c7149af7543026d62a9a450f26113.png";